import './jquery';
import './fslightbox';

/**
 * File single_product.js.
 *
 * Inits the carousel for product images
 */

 $(document).ready(function(){

    // Product images
    $('.product-image-carousel').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        adaptiveHeight: true,
        prevNextButtons: false
    });

    // Product details
    var $productDetails = $('.product-details-carousel').flickity({
        // options
        pageDots: false,
        adaptiveHeight: false,
        prevNextButtons: false
    });

    // Product details - previous
    $('.details-prev-button').on( 'click', function() {
        $productDetails.flickity('previous');
    });
    // Product details - next
    $('.details-next-button').on( 'click', function() {
        $productDetails.flickity('next');
    });

});

/**
 * File searchbar.js.
 *
 * Expands search bar on click
 */

 jQuery(document).ready(function($){

    var mouse_is_inside = false;

    $('a[href="#search"]').on('click', function(event) {
        event.preventDefault();
        $('#search').addClass('active-form');
        $('.search-input').focus();
    });

    $('.search-close').on('click', function(event) {
        event.preventDefault();
        $('#search').removeClass('active-form');
    });

    $('.search-form').hover(function(){ 
        mouse_is_inside=true; 
    }, function(){ 
        mouse_is_inside=false; 
    });

    $("body").mouseup(function(){ 
        if(! mouse_is_inside){
            $('#search').removeClass('active-form');
        }
    });

});

/**
 * File scripts.js.
 *
 * Used for general scripts
 */

 $(document).ready(function(){


    enableToolTips();

    function enableToolTips() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        })
    }

});

/**
 * File products_archive.js.
 *
 * Inits the carousel header in products archive
 */

 $(document).ready(function(){

    // Product images
    $('.product-archive-header-carousel').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        adaptiveHeight: true,
        prevNextButtons: false
    });

});

/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
 ( function() {
	const siteNavigation = document.getElementById( 'site-navigation' );

	// Return early if the navigation don't exist.
	if ( ! siteNavigation ) {
		return;
	}

	const button = siteNavigation.getElementsByTagName( 'button' )[ 0 ];

	// Return early if the button don't exist.
	if ( 'undefined' === typeof button ) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}

	if ( ! menu.classList.contains( 'nav-menu' ) ) {
		menu.classList.add( 'nav-menu' );
	}

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener( 'click', function() {
		siteNavigation.classList.toggle( 'toggled' );

		if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
			button.setAttribute( 'aria-expanded', 'false' );
		} else {
			button.setAttribute( 'aria-expanded', 'true' );
		}
	} );

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener( 'click', function( event ) {
		const isClickInside = siteNavigation.contains( event.target );

		if ( ! isClickInside ) {
			siteNavigation.classList.remove( 'toggled' );
			button.setAttribute( 'aria-expanded', 'false' );
		}
	} );

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName( 'a' );

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

	// Toggle focus each time a menu link is focused or blurred.
	for ( const link of links ) {
		link.addEventListener( 'focus', toggleFocus, true );
		link.addEventListener( 'blur', toggleFocus, true );
	}

	// Toggle focus each time a menu link with children receive a touch event.
	for ( const link of linksWithChildren ) {
		link.addEventListener( 'touchstart', toggleFocus, false );
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		if ( event.type === 'focus' || event.type === 'blur' ) {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while ( ! self.classList.contains( 'nav-menu' ) ) {
				// On li elements toggle the class .focus.
				if ( 'li' === self.tagName.toLowerCase() ) {
					self.classList.toggle( 'focus' );
				}
				self = self.parentNode;
			}
		}

		if ( event.type === 'touchstart' ) {
			const menuItem = this.parentNode;
			event.preventDefault();
			for ( const link of menuItem.parentNode.children ) {
				if ( menuItem !== link ) {
					link.classList.remove( 'focus' );
				}
			}
			menuItem.classList.toggle( 'focus' );
		}
	}
}() );


/**
 * File client_carousel.js.
 *
 * Inits the carousel for Clients carousel block
 */

 $(document).ready(function(){
    $('.bxslider').bxSlider({
        autoHover: true,
        auto: true,
        slideWidth: 250,
        minSlides: 2,
        maxSlides: 100,
        controls: false,
        pager: false,
        speed: 1000,
        slideMargin: 20,
        responsive: true,
      });
});